// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"88":"0dbaac44","991":"42f86cc8"}[chunkId] + ".chunk.js");